import { render, staticRenderFns } from "./deliveryDetailItem.vue?vue&type=template&id=05fb2cdd&scoped=true&"
import script from "./deliveryDetailItem.vue?vue&type=script&lang=js&"
export * from "./deliveryDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDetailItem.vue?vue&type=style&index=0&id=05fb2cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb2cdd",
  null
  
)

export default component.exports